export enum VisitSchedulingFormField {
  VISIT_SCHEDULING_PATIENT_SCHEDULE_WAKEUP_TIME = 'visit-scheduling/patient-schedule/wakeup-time',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_BEDTIME = 'visit-scheduling/patient-schedule/bedtime',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES = 'visit-scheduling/patient-schedule/school-times',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_DAY = 'visit-scheduling/patient-schedule/school-times/day',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD = 'visit-scheduling/patient-schedule/school-times/period',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS = 'visit-scheduling/patient-schedule/other-appointments',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VALID = 'visit-scheduling/custom-schedule/valid',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS = 'visit-scheduling/custom-schedule/visits',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_EDITED_VISITS = 'visit-scheduling/custom-schedule/edited-visits',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_BY_WEEKDAY = 'visit-scheduling/custom-schedule/weekday-visits',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_CHANGE_REASON = 'visit-scheduling/custom-schedule/change-reason',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_ADDITIONAL_NOTES = 'visit-scheduling/custom-schedule/additional-notes'
}
